import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Configuration } from 'src/app/app.constants';
import {
  LocationGroupDetail,
  LocationGroupListItem,
  LocationGroupSaveRequest,
  VenueBuilding,
  VenueLocationDetail,
  VenueZone,
} from '../models/location-assignment.model';

@Injectable()
export class LocationGroupHttpService {
  constructor(
    private readonly http: HttpClient,
    private readonly configuration: Configuration,
  ) {}

  /**
   * Gets one page of location groups for the current context venue.
   *
   * @param page page number.
   * @param size Page size.
   * @param search Optional name filter.
   * @returns Location group list
   */
  GetLocationGroupsByVenue = (page: number, size: number, search: string): Observable<LocationGroupListItem[]> => {
    let params = new HttpParams();
    if (search) {
      params = params.set('search', search);
    }
    const _url: string = this.configuration.Server + 'v2/facility/location-groups/' + page + '/' + size;
    return this.http.get<LocationGroupListItem[]>(_url, { params });
  };

  /**
   * Gets a single location group details for the edit form.
   *
   * @param identity The group's identity GUID.
   */
  GetLocationGroupById = (identity: string): Observable<LocationGroupDetail> => {
    const _url: string = this.configuration.Server + 'v2/facility/location-group/' + identity;
    return this.http.get<LocationGroupDetail>(_url);
  };

  /**
   * Creates a new location group with its selected locations
   *
   * @param body Group name and location ids.
   */
  CreateLocationGroup = (body: LocationGroupSaveRequest): Observable<void> => {
    const _url: string = this.configuration.Server + 'v2/facility/location-group';
    return this.http.post<void>(_url, body);
  };

  /**
   * Updates an existing location group.
   *
   * @param body Updated location group details
   */
  UpdateLocationGroup = (body: LocationGroupSaveRequest): Observable<void> => {
    const _url: string = this.configuration.Server + 'v2/facility/location-group';
    return this.http.put<void>(_url, body);
  };

  /**
   * Method to delete a location group
   *
   * @param identity The group's identity GUID.
   */
  DeleteLocationGroup = (identity: string): Observable<void> => {
    const _url: string = this.configuration.Server + 'v2/facility/location-group/' + identity;
    return this.http.delete<void>(_url);
  };

  /**
   * Gets all active buildings for the current context venue
   */
  GetVenueBuildings = (): Observable<VenueBuilding[]> => {
    const _url: string = this.configuration.Server + 'v2/facility/buildings-all';
    return this.http.get<VenueBuilding[]>(_url);
  };

  /**
   * Gets all active zones for the current context venue.
   */
  GetVenueZones = (): Observable<VenueZone[]> => {
    const _url: string = this.configuration.Server + 'v2/facility/zones-all';
    return this.http.get<VenueZone[]>(_url);
  };

  /**
   * Gets all active locations for the current context venue.
   */
  GetVenueLocations = (): Observable<VenueLocationDetail[]> => {
    const _url: string = this.configuration.Server + 'v2/facility/locations-all';
    return this.http.get<VenueLocationDetail[]>(_url);
  };
}
